module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dic-body"
  }, [_c('h1', {
    staticClass: "dictionary-title"
  }, [_vm._v(_vm._s(_vm.$t("dictionary.dictionary.dict")))]), _vm._v(" "), _c('div', {
    staticClass: "dic-container",
    style: (_vm.safeZones)
  }, [_c('div', [_c('Search', {
    on: {
      "selectedWord": _vm.selectedWord,
      "addWord": _vm.addWord
    }
  }), _vm._v(" "), (_vm.word) ? _c('Box', {
    attrs: {
      "language": _vm.language,
      "word": _vm.word,
      "savedWords": _vm.savedWords,
      "hebSen": _vm.hebSen,
      "arabSen": _vm.arabSen,
      "sentenceId": _vm.sentenceId,
      "sentences": _vm.sentences
    },
    on: {
      "search": _vm.searchWord,
      "saveWord": _vm.saveWord
    }
  }) : _vm._e(), _vm._v(" "), (_vm.msg) ? _c('div', {
    staticClass: "msg"
  }, [_vm._v(_vm._s(_vm.msg))]) : _vm._e()], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "500"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t("dictionary.dictionary.title")) + "\n        ")]), _vm._v(" "), _c('v-card-text', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.wordSuggestion),
      expression: "wordSuggestion"
    }],
    staticClass: "textBox",
    attrs: {
      "id": "addword",
      "name": "addword",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.wordSuggestion)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.wordSuggestion = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "sendBtn",
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": _vm.sendWordRequest
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t("dictionary.dictionary.send")) + "\n          ")])], 1)], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2443c47a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dictionary/Dictionary.vue
// module id = 386
// module chunks = 0 5